import type { Theme } from '@mui/material/styles';

export default function Grid(_theme: Theme) {
  return {
    MuiGrid: {
      styleOverrides: {}
    }
  };
}
